<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 offset-lg-1 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Menú app</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm" style="width: 100%" id="menu-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Nombre</th>
                                                <th scope="col">Imagen</th>
                                                <th scope="col">Cambiar</th>
                                                <th scope="col">Estado</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="ad in ads" :key="ad.id">
                                                <td>{{ ad.id }}</td>
                                                <td>{{ ad.code }}</td>
                                                <td>
                                                    <img  v-if="ad.url" :src="ad.url" width="80px" alt="">
                                                </td>
                                                <td>
                                                    <input required @change="selectImage($event, ad)" accept="image/x-png,image/gif,image/jpeg" type="file" ref="image">
                                                </td>
                                                <td class="text-center">
                                                    <p>{{ (ad.status) ? 'Activo' : 'Inactivo' }}</p>
                                                </td>
                                                <td width="50px">
                                                    <a href="#" class="btn btn-danger btn-sm" @click="changeStatusAd(ad)"><i class="fa fa-ban"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ads',
    mounted: function(){
        this.fetchAds();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            currentCity: null,
            ads: {},
        }
    },
    methods: {
        fetchAds: function(){
            let loader = this.$loading.show();
            
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/ads`)
            .then(data => {
                _this.ads = data.body.data;
                loader.hide();

                console.log(_this.ads);
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        selectImage(e, ad){
            let file = e.target.files[0];

            if (file) {
                const formData = new FormData();
                formData.append('image', file);
                formData.append('id', ad.id);

                let loader = this.$loading.show();
                this.$http.post(`${this.baseUrl}/admin/ads`, formData)
                .then(() => {
                    this.fetchAds();
                    this.$dialogs.alert("Estado del menú actualizado con exito", {title: "Éxito", size: "sm"});
                    loader.hide();
                    window.location.reload();
                })
                .catch(error => {
                    console.log(error.error);
                    loader.hide();
                });
            }
        },
        changeStatusAd: function(ad) {
            let loader = this.$loading.show();
            this.$http.put(`${this.baseUrl}/admin/ads/${ad.id}`, {status: !ad.status})
            .then(() => {
                this.fetchAds();
                this.$dialogs.alert("Estado del menú actualizado con exito", {title: "Éxito", size: "sm"});
                loader.hide();
                window.location.reload();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        }
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


